import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import * as patient_actions from '../../../store/patient/actions';
import ModalAddDocument from './patient-documents/modal-add-document';
import ModalEditDocument from './patient-documents/modal-edit-document';
import ModalDeleteDocument from './patient-documents/modal-delete-document';
import { cloneDeep } from 'lodash';
import file_api from '../../../api/file-api';
import moment from 'moment';
import { createUUID } from '../../react-flow-pedigree/utils';

class PatientDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeleteDocumentModal: false,
      showAddDocumentModal: false,
      showEditDocumentModal: false,
      documentEditing: null,
      downloadFailed: false
    };

    this.openAddDocumentModal  = this.openAddDocumentModal.bind(this);
    this.closeAddDocumentModal = this.closeAddDocumentModal.bind(this);

    this.openEditDocumentmodal  = this.openEditDocumentmodal.bind(this);
    this.closeEditDocumentModal = this.closeEditDocumentModal.bind(this);

    this.onClickDeleteDocument    = this.onClickDeleteDocument.bind(this);
    this.openDeleteDocumentmodal  = this.openDeleteDocumentmodal.bind(this);
    this.closeDeleteDocumentModal = this.closeDeleteDocumentModal.bind(this);

    this.onSaveDocument = this.onSaveDocument.bind(this);
    this.downloadDocument = this.downloadDocument.bind(this);
  }

  async componentDidMount() {
    let member_id = this.props.getPedigreeData !== null && this.props.getPedigreeData !== undefined ? this.props.getPedigreeData().proband.id : this.props.member_id
    let files = await file_api.get_user_files(member_id);
    let documents = {};
    files.forEach(document => {
      let docKey = createUUID();
      documents[docKey] = document;
    });
    this.props.dispatch(patient_actions.save_documents(documents));
  }

  openAddDocumentModal(event) {
    this.setState({showAddDocumentModal: true});
  }

  closeAddDocumentModal() {
    this.setState({showAddDocumentModal: false});
  }

  openEditDocumentmodal(event) {
    this.setState({
      showEditDocumentModal: true,
      documentEditing: {rkey: event.currentTarget.name, document: this.props.documents[event.currentTarget.name]}
    });
  }

  closeEditDocumentModal() {
    this.setState({
      showEditDocumentModal: false,
      documentEditing: null
    });
  }

  openDeleteDocumentmodal(event) {
    this.setState({
      showDeleteDocumentModal: true,
      documentEditing: {rkey: event.currentTarget.name, document: this.props.documents[event.currentTarget.name]}
    });
  }

  closeDeleteDocumentModal() {
    this.setState({showDeleteDocumentModal: false});
  }

  async onSaveDocument() {
    let member_id = this.props.getPedigreeData !== null && this.props.getPedigreeData !== undefined ? this.props.getPedigreeData().proband.id : this.props.member_id
    let files = await file_api.get_user_files(member_id);
    let documents = {};
    files.forEach(document => {
      let docKey = createUUID();
      documents[docKey] = document;
    });
    this.props.dispatch(patient_actions.save_documents(documents));
  }

  async onClickDeleteDocument(payload) {
    let { deleteKey } = payload;
    let doc = this.props.documents[deleteKey];
    if(doc) {
      let response = await file_api.delete_user_file_from_aws(doc.uuid_filename);
      this.props.dispatch(patient_actions.delete_document(payload));
    }
  }

  async downloadDocument(event) {
    const name = event.currentTarget.name;
    let doc = this.props.documents[name];
    if(doc) {
      let response = await file_api.download_user_file(doc.uuid_filename);
      if ('data' in response) {
        const id = "#download-container";
        const child = document.body.querySelector(id);
        if(child) {
          child.href = response.data.url;
          child.click();
          child.href = '';
        }
      }

      if ('error' in response) {
        this.setState({downloadFailed: true});
        setTimeout( () => {
          this.setState({downloadFailed: false});
        }, 5000);
      }
    }
  }

  getLocaleDateString = () => {
    var formats = { "ar-SA": "DD/MM/YY", "bg-BG": "DD.MM.YYYY", "ca-ES": "DD/MM/YYYY", "zh-TW": "YYYY/MM/DD", "cs-CZ": "DD.MM.YYYY", "da-DK": "DD-MM-YYYY", "de-DE": "DD.MM.YYYY", "el-GR": "DD/MM/YYYY", "en": "MM/DD/YYYY", "en-US": "MM/DD/YYYY", "fi-FI": "DD.MM.YYYY", "fr-FR": "DD/MM/YYYY", "he-IL": "DD/MM/YYYY", "hu-HU": "YYYY. MM. DD.", "is-IS": "DD.MM.YYYY", "it-IT": "DD/MM/YYYY", "ja-JP": "YYYY/MM/DD", "ko-KR": "YYYY-MM-DD", "nl-NL": "DD-MM-YYYY", "nb-NO": "DD.MM.YYYY", "pl-PL": "YYYY-MM-DD", "pt-BR": "DD/MM/YYYY", "ro": "DD.MM.YYYY", "ro-RO": "DD.MM.YYYY", "ru-RU": "DD.MM.YYYY", "hr-HR": "DD.MM.YYYY", "sk-SK": "DD. MM. YYYY", "sq-AL": "YYYY-MM-DD", "sv-SE": "YYYY-MM-DD", "th-TH": "DD/MM/YYYY", "tr-TR": "DD.MM.YYYY", "ur-PK": "DD/MM/YYYY", "id-ID": "DD/MM/YYYY", "uk-UA": "DD.MM.YYYY", "be-BY": "DD.MM.YYYY", "sl-SI": "DD.MM.YYYY", "et-EE": "DD.MM.YYYY", "lv-LV": "YYYY.MM.DD.", "lt-LT": "YYYY.MM.DD", "fa-IR": "MM/DD/YYYY", "vi-VN": "DD/MM/YYYY", "hy-AM": "DD.MM.YYYY", "az-Latn-AZ": "DD.MM.YYYY", "eu-ES": "YYYY/MM/DD", "mk-MK": "DD.MM.YYYY", "af-ZA": "YYYY/MM/DD", "ka-GE": "DD.MM.YYYY", "fo-FO": "DD-MM-YYYY", "hi-IN": "DD-MM-YYYY", "ms-MY": "DD/MM/YYYY", "kk-KZ": "DD.MM.YYYY", "ky-KG": "DD.MM.YY", "sw-KE": "MM/DD/YYYY", "uz-Latn-UZ": "DD/MM YYYY", "tt-RU": "DD.MM.YYYY", "pa-IN": "DD-MM-YY", "gu-IN": "DD-MM-YY", "ta-IN": "DD-MM-YYYY", "te-IN": "DD-MM-YY", "kn-IN": "DD-MM-YY", "mr-IN": "DD-MM-YYYY", "sa-IN": "DD-MM-YYYY", "mn-MN": "YY.MM.DD", "gl-ES": "DD/MM/YY", "kok-IN": "DD-MM-YYYY", "syr-SY": "DD/MM/YYYY", "dv-MV": "DD/MM/YY", "ar-IQ": "DD/MM/YYYY", "zh-CN": "YYYY/MM/DD", "de-CH": "DD.MM.YYYY", "en-GB": "DD/MM/YYYY", "es-MX": "DD/MM/YYYY", "fr-BE": "DD/MM/YYYY", "it-CH": "DD.MM.YYYY", "nl-BE": "DD/MM/YYYY", "nn-NO": "DD.MM.YYYY", "pt-PT": "DD-MM-YYYY", "sr-Latn-CS": "DD.MM.YYYY", "sv-FI": "DD.MM.YYYY", "az-Cyrl-AZ": "DD.MM.YYYY", "ms-BN": "DD/MM/YYYY", "uz-Cyrl-UZ": "DD.MM.YYYY", "ar-EG": "DD/MM/YYYY", "zh-HK": "DD/MM/YYYY", "de-AT": "DD.MM.YYYY", "en-AU": "DD/MM/YYYY", "es-ES": "DD/MM/YYYY", "fr-CA": "YYYY-MM-DD", "sr-Cyrl-CS": "DD.MM.YYYY", "ar-LY": "DD/MM/YYYY", "zh-SG": "DD/MM/YYYY", "de-LU": "DD.MM.YYYY", "en-CA": "DD/MM/YYYY", "es-GT": "DD/MM/YYYY", "fr-CH": "DD.MM.YYYY", "ar-DZ": "DD-MM-YYYY", "zh-MO": "DD/MM/YYYY", "de-LI": "DD.MM.YYYY", "en-NZ": "DD/MM/YYYY", "es-CR": "DD/MM/YYYY", "fr-LU": "DD/MM/YYYY", "ar-MA": "DD-MM-YYYY", "en-IE": "DD/MM/YYYY", "es-PA": "MM/DD/YYYY", "fr-MC": "DD/MM/YYYY", "ar-TN": "DD-MM-YYYY", "en-ZA": "YYYY/MM/DD", "es-DO": "DD/MM/YYYY", "ar-OM": "DD/MM/YYYY", "en-JM": "DD/MM/YYYY", "es-VE": "DD/MM/YYYY", "ar-YE": "DD/MM/YYYY", "en-029": "MM/DD/YYYY", "es-CO": "DD/MM/YYYY", "ar-SY": "DD/MM/YYYY", "en-BZ": "DD/MM/YYYY", "es-PE": "DD/MM/YYYY", "ar-JO": "DD/MM/YYYY", "en-TT": "DD/MM/YYYY", "es-AR": "DD/MM/YYYY", "ar-LB": "DD/MM/YYYY", "en-ZW": "MM/DD/YYYY", "es-EC": "DD/MM/YYYY", "ar-KW": "DD/MM/YYYY", "en-PH": "MM/DD/YYYY", "es-CL": "DD-MM-YYYY", "ar-AE": "DD/MM/YYYY", "es-UY": "DD/MM/YYYY", "ar-BH": "DD/MM/YYYY", "es-PY": "DD/MM/YYYY", "ar-QA": "DD/MM/YYYY", "es-BO": "DD/MM/YYYY", "es-SV": "DD/MM/YYYY", "es-HN": "DD/MM/YYYY", "es-NI": "DD/MM/YYYY", "es-PR": "DD/MM/YYYY", "am-ET": "DD/MM/YYYY", "tzm-Latn-DZ": "DD-MM-YYYY", "iu-Latn-CA": "DD/MM/YYYY", "sma-NO": "DD.MM.YYYY", "mn-Mong-CN": "YYYY/MM/DD", "gd-GB": "DD/MM/YYYY", "en-MY": "DD/MM/YYYY", "prs-AF": "DD/MM/YY", "bn-BD": "DD-MM-YY", "wo-SN": "DD/MM/YYYY", "rw-RW": "MM/DD/YYYY", "qut-GT": "DD/MM/YYYY", "sah-RU": "MM.DD.YYYY", "gsw-FR": "DD/MM/YYYY", "co-FR": "DD/MM/YYYY", "oc-FR": "DD/MM/YYYY", "mi-NZ": "DD/MM/YYYY", "ga-IE": "DD/MM/YYYY", "se-SE": "YYYY-MM-DD", "br-FR": "DD/MM/YYYY", "smn-FI": "DD.MM.YYYY", "moh-CA": "MM/DD/YYYY", "arn-CL": "DD-MM-YYYY", "ii-CN": "YYYY/mM/DD", "dsb-DE": "DD. MM. YYYY", "ig-NG": "DD/MM/YYYY", "kl-GL": "DD-MM-YYYY", "lb-LU": "DD/MM/YYYY", "ba-RU": "DD.MM.YY", "nso-ZA": "YYYY/MM/DD", "quz-BO": "DD/MM/YYYY", "yo-NG": "DD/MM/YYYY", "ha-Latn-NG": "DD/MM/YYYY", "fil-PH": "MM/DD/YYYY", "ps-AF": "DD/MM/YY", "fy-NL": "DD-MM-YYYY", "ne-NP": "MM/DD/YYYY", "se-NO": "DD.MM.YYYY", "iu-Cans-CA": "DD/MM/YYYY", "sr-Latn-RS": "DD.MM.YYYY", "si-LK": "YYYY-MM-DD", "sr-Cyrl-RS": "DD.MM.YYYY", "lo-LA": "DD/MM/YYYY", "km-KH": "YYYY-MM-DD", "cy-GB": "DD/MM/YYYY", "bo-CN": "YYYY/MM/DD", "sms-FI": "DD.MM.YYYY", "as-IN": "DD-MM-YYYY", "ml-IN": "DD-MM-YY", "en-IN": "DD-MM-YYYY", "or-IN": "DD-MM-YY", "bn-IN": "DD-MM-YY", "tk-TM": "DD.MM.YY", "bs-Latn-BA": "DD.MM.YYYY", "mt-MT": "DD/MM/YYYY", "sr-Cyrl-ME": "DD.MM.YYYY", "se-FI": "DD.MM.YYYY", "zu-ZA": "YYYY/MM/DD", "xh-ZA": "YYYY/MM/DD", "tn-ZA": "YYYY/MM/DD", "hsb-DE": "DD. MM. YYYY", "bs-Cyrl-BA": "DD.MM.YYYY", "tg-Cyrl-TJ": "DD.MM.YY", "sr-Latn-BA": "DD.MM.YYYY", "smj-NO": "DD.MM.YYYY", "rm-CH": "DD/MM/YYYY", "smj-SE": "YYYY-MM-DD", "quz-EC": "DD/MM/YYYY", "quz-PE": "DD/MM/YYYY", "hr-BA": "DD.MM.YYYY.", "sr-Latn-ME": "DD.MM.YYYY", "sma-SE": "YYYY-MM-DD", "en-SG": "DD/MM/YYYY", "ug-CN": "YYYY-MM-DD", "sr-Cyrl-BA": "DD.MM.YYYY", "es-US": "MM/DD/YYYY" }
    return formats[navigator.language] ||  'DD/MM/YYYY';
  }

  render() {
    let counter = 1;
    const documents = this.props.documents;
    let member_id = this.props.getPedigreeData !== null && this.props.getPedigreeData !== undefined ? this.props.getPedigreeData().proband.id : this.props.member_id

    const tableRows = Object.keys(documents).map((key) =>
      <tr key={key.toString()} role="row" className={( (counter++ % 2) === 0) ? "even" : "odd"}>
        <td>
          <Link name={key} to="#" onClick={this.downloadDocument}>{documents[key].custom_filename}</Link>
        </td>
        <td>{documents[key].file_category}</td>
        <td>{moment(documents[key].created_at).format(this.getLocaleDateString())}</td>
        <td>{documents[key].file_note}</td>
        <td>
          <ul className="table-action">
						<li><button name={key.toString()} onClick={this.openEditDocumentmodal}><i className="fa fa-pencil"></i></button></li>
						<li><button name={key.toString()} onClick={this.openDeleteDocumentmodal}><i className="fa fa-remove"></i></button></li>
					</ul>
        </td>
      </tr>
    );

    let modal = null;
    if(this.state.showAddDocumentModal) {
      modal = <ModalAddDocument
                onClose={this.closeAddDocumentModal}
                onClickSave={(payload) => this.onSaveDocument(payload)}
                member_id={member_id}
              />;
    } else if(this.state.showEditDocumentModal) {
      modal = <ModalEditDocument
                onClose={this.closeEditDocumentModal}
                onClickSave={(payload) => this.onSaveDocument(payload)}
                documentEditing={this.state.documentEditing}
              />;
    } else if(this.state.showDeleteDocumentModal) {
        modal = <ModalDeleteDocument
                  onClose={this.closeDeleteDocumentModal}
                  onClickDelete={(payload) => this.onClickDeleteDocument(payload)}
                  documentEditing={this.state.documentEditing}
                />;
    }

    return (
      <React.Fragment>

        <a id="download-container" href="" style={{position: 'absolute', right: '2000px'}}></a>
        <button className="btn btn-teal btn-xs no-margin-top margin-two-bottom" onClick={this.openAddDocumentModal}><i className="fa fa-plus"></i> Add Document</button>

        {this.state.downloadFailed && (
          <div className="utility-warning-box">
            Download Failed
          </div>
        )}
        <div className="row">
          <div className="col-lg-10">
            <div id="table-doc_wrapper" className="dataTables_wrapper">
              <table id="table-doc" className="display table-custom responsive no-wrap dataTable" role="grid">
                <thead>
                  <tr role="row">
                    <th className="sorting_disabled">Name</th>
                    <th className="sorting_disabled">Type</th>
                    <th className="sorting_disabled">Date</th>
                    <th className="sorting_disabled">Notes</th>
                    <th className="sorting_disabled"></th>
                  </tr>
                </thead>

                <tbody>
                  {tableRows}
                </tbody>

                <tfoot className="hidden">
                  <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Date</th>
                    <th>Notes</th>
                    <th></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        {modal}
      </React.Fragment>
    );
  }
}

const redux_state = state => ({
  documents: state.patient.documents,
  member_id: state.patient.patient.id
});

const redux_actions = dispatch => ({
  dispatch: (action) => dispatch(action)
});

export default connect(redux_state, redux_actions)(PatientDocuments);
